import ReactMarkdown from 'react-markdown'
import rehypeRaw from 'rehype-raw'

import type { MarkdownPreviewProps } from './_types'
import { PreviewContainer } from './MarkdownPreview.styles'

export const MarkdownPreview = ({
  source,
  maxLength,
  className,
  placeholder = '',
  components,
}: MarkdownPreviewProps) => {
  const value =
    maxLength && source && source?.length > maxLength ? `${source?.slice(0, maxLength)}...` : source

  const valueToRender = value || placeholder
  const isPlaceholder = !value

  return (
    <PreviewContainer data-testid="preview" className={className}>
      <ReactMarkdown
        rehypePlugins={[rehypeRaw]}
        components={{
          ...(isPlaceholder
            ? { p: ({ children }) => <p className="placeholder">{children}</p> }
            : {}),
          ...components,
        }}
      >
        {valueToRender}
      </ReactMarkdown>
    </PreviewContainer>
  )
}
